import script from "./MyFormM2MTableField.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyFormM2MTableField.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__